import styled from 'styled-components';

export const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(44, 48, 56, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

export const ModalContainer = styled.div`
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.16);
  width: 50vw;
  max-width: 700px;
  min-width: 380px;
  min-height: 400px; /* example minimum height */
  max-height: 80vh; /* limited by viewport height */
  overflow-y: auto; /* enable scroll if content exceeds max-height */
  padding: 32px;
  position: relative;
  box-sizing: border-box;
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 100px;
  padding: 12px 20px; /* Increased padding */
  font-size: 1.2rem; /* Increased font size */
  border-radius: 10px;
  border: 1px solid #d1d5db;
  outline: none;
  background-color: #fff;
  box-sizing: border-box;
  resize: vertical;

  &:focus {
    border-color: #5542cc;
  }
`;

export const Header = styled.h3`
  margin: 0 0 28px 0;
  text-align: center;
  font-weight: bold;
  font-size: 1.8rem; /* Increased from 1.3rem */
  user-select: none;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px;
  margin-bottom: 18px;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 7px;
  font-weight: 600;
  font-size: 1.2rem; /* Increased from 1rem */
  user-select: none;
`;

export const Input = styled.input<{ disabled?: boolean }>`
  width: 100%;
  padding: 12px 20px; /* Increased padding for comfort */
  font-size: 1.2rem; /* Increased from 1rem */
  border-radius: 10px;
  border: 1px solid #d1d5db;
  outline: none;
  background-color: ${({ disabled }) => (disabled ? '#f5f5f5' : '#fff')};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'auto')};
  box-sizing: border-box;

  &:focus {
    border-color: #5542cc;
  }
`;

export const Select = styled.select`
  width: 100%;
  padding: 12px 20px; /* Increased padding */
  font-size: 1.2rem; /* Increased font size */
  border-radius: 10px;
  border: 1px solid #d1d5db;
  outline: none;
  background-color: #fff;
  box-sizing: border-box;

  &:focus {
    border-color: #5542cc;
  }
`;

export const Footer = styled.div`
  text-align: right;
  margin-top: 38px;
`;

export const SaveButton = styled.button`
  padding: 9px 38px;
  background-color: #5542cc;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-weight: bold;
  font-size: 1rem;
  cursor: pointer;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 22px;
  right: 32px;
  background: transparent;
  border: none;
  font-size: 1.5rem;
  color: #888;
  cursor: pointer;
  user-select: none;
`;
